/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_contact_proposal_title_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What tool should we build?`)
};

const es_contact_proposal_title_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Qué herramienta deberíamos crear?`)
};

const de_contact_proposal_title_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Welches Tool sollen wir entwickeln?`)
};

const nl_contact_proposal_title_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Welke tool moeten we bouwen?`)
};

const fr_contact_proposal_title_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quel outil devrions-nous créer ?`)
};

const it_contact_proposal_title_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quale strumento dovremmo creare?`)
};

const pt_br2_contact_proposal_title_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Que ferramenta devemos criar?`)
};

const pt_contact_proposal_title_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Que ferramenta devemos criar?`)
};

const ja_contact_proposal_title_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`どんなツールを作るべきですか？`)
};

const zh_contact_proposal_title_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我们应该做什么工具？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const contact_proposal_title_hint = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.contact_proposal_title_hint(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("contact_proposal_title_hint", locale)
	if (locale === "en") return en_contact_proposal_title_hint(inputs)
	if (locale === "es") return es_contact_proposal_title_hint(inputs)
	if (locale === "de") return de_contact_proposal_title_hint(inputs)
	if (locale === "nl") return nl_contact_proposal_title_hint(inputs)
	if (locale === "fr") return fr_contact_proposal_title_hint(inputs)
	if (locale === "it") return it_contact_proposal_title_hint(inputs)
	if (locale === "pt-BR") return pt_br2_contact_proposal_title_hint(inputs)
	if (locale === "pt") return pt_contact_proposal_title_hint(inputs)
	if (locale === "ja") return ja_contact_proposal_title_hint(inputs)
	return zh_contact_proposal_title_hint(inputs)
};